import {ContentEditableHtmlEditorPlugin} from '@frontapp/editor-html';

import {blockquoteStyle} from '../../../../../../srcCommon/styles/editorStyles';

/** Adds Front styling to blockquotes that otherwise have no styling. */
export function createBlockquoteStylePlugin(): ContentEditableHtmlEditorPlugin {
  return {
    processTree: (element) => {
      const nodeList = element.querySelectorAll<HTMLQuoteElement>('blockquote');
      for (let i = 0; i < nodeList.length; i++) {
        const node = nodeList[i];
        if (!node.hasAttribute('class') && !node.hasAttribute('style')) {
          node.setAttribute('style', blockquoteStyle);
        }
      }
    },
  };
}
